import { TSelectOption } from 'shared/types'

export const avatarSizes = {
  xl: 640,
  m: 320,
  s: 160,
  xs: 160
}

export const DEFAULT_ENTITIES_LIMIT = 30

export const SKELETON_ITEMS_COUNT = 5

export const PRODUCT_CONFIGURATION_OPTIONS: TSelectOption[] = [
  {
    label: 'Single',
    value: 'single'
  },
  {
    label: 'Album',
    value: 'album'
  },
  {
    label: 'EP',
    value: 'ep'
  }
]

export const PRODUCT_TRACK_STATUS_OPTIONS: TSelectOption[] = [
  {
    label: '-- No Track Status --',
    value: '',
  },
  {
    label: 'Track of the week',
    value: 'trackoftheweek'
  },
  {
    label: 'Surging Track',
    value: 'surgingtrack'
  },
  {
    label: 'Radar',
    value: 'radar'
  }
]

export const imgRegexp = /^image\/(gif|jpe?g|a?png|svg|webp|bmp|vnd\.microsoft\.icon)/i
export const MAX_FILE_SIZE = 3 * 1024 * 1024

export const GALLERY_ITEMS_LENGTH = 5

export const headerHeight = 55

export enum ECountryCodes {
  de = 'DE',
  at = 'AT',
  ch = 'CH',
  au = 'AU',
  nz = 'NZ'
}

export enum EDateFormatsByCountry {
  DE = 'dd.MM.yy',
  AT = 'dd.MM.yy',
  CH = 'dd.MM.yy',
  AU = 'dd/MM/yy',
  NZ = 'dd/MM/yy'
}

export enum EMaskFormatsByCountry {
  DE = '99.99.99',
  AT = '99.99.99',
  CH = '99.99.99',
  AU = '99/99/99',
  NZ = '99/99/99'
}

export const SERVER_MESSAGE_DEFAULT = 'Something with server. Please try again later'
